import { Flex, Span } from "@goodfill/ui-components";
import { FC, PropsWithChildren, ReactNode } from "react";

interface FieldGroupProps {
  label?: ReactNode;
  labelRight?: ReactNode;
  subLabel?: ReactNode;
  validation?: string[];
  fill?: boolean;
  className?: string;
  isCol?: boolean;
  popoverDiv?: React.ReactNode;
}

export const FieldGroup: FC<PropsWithChildren<FieldGroupProps>> = ({
  fill,
  children,
  label,
  labelRight,
  subLabel,
  validation = [],
  className,
  isCol = true,
  popoverDiv,
}) => {
  const uniqValidation = [...new Set([...validation])];

  return (
    <Flex direction="col" verticalMargin={4} gap={1} width={fill ? "w-full" : 80} className={className}>
      <Flex direction="col" width={fill ? "w-full" : 80} className={className}>
        {label && (
          <Flex direction="row" justify={`${popoverDiv ? "start" : "between"}`} items="center">
            <Span font="medium" style={{ paddingLeft: "0" }} wrap>
              {label}
            </Span>
            {popoverDiv}
            <Span font="medium" style={{ paddingRight: "0" }} wrap>
              {labelRight}
            </Span>
          </Flex>
        )}
        {subLabel && (
          <Span
            font={"light"}
            style={{
              display: "block",
              whiteSpace: "pre-wrap",
            }}
          >
            {subLabel}
          </Span>
        )}
      </Flex>
      {isCol ? (
        <>
          <Flex direction={`${isCol ? "col" : "row"}`} gap={3} width={fill ? "w-full" : 80} className={className}>
            {children}
            {uniqValidation.length > 0 && (
              <Span wrap red={true} size="xs" style={{ paddingLeft: "0" }}>
                {uniqValidation.join(", ")}
              </Span>
            )}
          </Flex>
        </>
      ) : (
        <>
          <Flex direction={`${isCol ? "col" : "row"}`} gap={3} width={fill ? "w-full" : 80} className={className}>
            {children}
          </Flex>
          {uniqValidation.length > 0 && (
            <Span wrap red={true} size="xs" style={{ paddingLeft: "0", paddingTop: "5px" }}>
              {uniqValidation.join(", ")}
            </Span>
          )}
        </>
      )}
    </Flex>
  );
};
